import FilesRootView from './FilesRootView'
import FileDetailsView from './FileDetailsView'
import FileDetailsEditView from './FileDetailsEditView'

export {
    FilesRootView,
    FileDetailsView,
    FileDetailsEditView
}
